module.exports = __webpack_public_path__ + "static/media/SchoolCosContImprove.701f35d6.png";